require('./bootstrap');
require('./vue');

import moment from 'moment-timezone';
import Vue from 'vue';
import SearchComponent from './components/SearchComponent.vue';
import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);
window.moment = moment;

$(document).ready(
    function() {
        if ( $( "#searchApp" ).length ){
            new Vue({
                el: '#searchApp',
                render: h => h(SearchComponent),
            });
        }

        $('.badge-expander').mouseenter(
            function () { $(this).children('.badge-expanding').fadeIn(); }
        ).mouseleave(
            function () { $(this).children('.badge-expanding').fadeOut(); }
        )

        $('.dropdown-item').hover(function () {
            $(this).find('.dropdown-menu')
               .stop(true, true).fadeIn(200);
        }, function () {
            $(this).find('.dropdown-menu')
              .stop(true, true).fadeOut(200);
        });
    }
);

// Enable Tool Tips
$('[data-toggle="tooltip"]').tooltip();

$('#btn-search').on('click', function(event) {
    event.preventDefault();
    $('#overlay-search').addClass('open');
    $('#overlay-search > form > input[type="search"]').focus();
});

$('#overlay-search, #overlay-search button.close').on('click keyup', function(event) {
    if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
        $(this).removeClass('open');
    }
});

//  Reach this point? Great. All has been loaded.
let bar = ""; for(var i = 0; i < 45; i++) { bar += "-"; }
window.log.info(bar+"\nSustainable Brands a hoş geldiniz.\nCopyright ©2021, Sustainable Brands, PBC\nAll Rights Reserved.\n"+bar);
